var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5334_17320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5334_17320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7405 14.7496H13.2595L12.6943 11.5918C13.0083 11.4572 13.2611 11.246 13.4528 10.9583C13.6444 10.6705 13.7402 10.3509 13.7402 9.99959C13.7402 9.52009 13.5701 9.11017 13.2298 8.76984C12.8894 8.4295 12.4795 8.25934 12 8.25934C11.5205 8.25934 11.1106 8.4295 10.7702 8.76984C10.4299 9.11017 10.2598 9.52009 10.2598 9.99959C10.2598 10.3509 10.3556 10.6705 10.5473 10.9583C10.7389 11.246 10.9918 11.4572 11.3058 11.5918L10.7405 14.7496ZM12 21.4803C9.83717 20.8905 8.0465 19.6174 6.628 17.6611C5.20933 15.7048 4.5 13.5176 4.5 11.0996V5.34584L12 2.53809L19.5 5.34584V11.0996C19.5 13.5176 18.7907 15.7048 17.372 17.6611C15.9535 19.6174 14.1628 20.8905 12 21.4803ZM12 19.8996C13.7333 19.3496 15.1667 18.2496 16.3 16.5996C17.4333 14.9496 18 13.1163 18 11.0996V6.37459L12 4.13409L6 6.37459V11.0996C6 13.1163 6.56667 14.9496 7.7 16.5996C8.83333 18.2496 10.2667 19.3496 12 19.8996Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/securityIcon.c7632a554a9c187466c0600862b9df2f.svg";
export { ForwardRef as ReactComponent };